import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";
import Login from "../pages/Login";
import ChangePassword from "../pages/ChangePassword";
import MfaSetup from "../pages/MfaSetup";

export default function AuthGate({ children }) {
  const { status, mustChangePassword, mustEnrollMfa } = useAuth();

  if (status === "checking") {
    return (
      <div
        className="min-h-screen w-screen flex items-center justify-center bg-[#09090B] text-zinc-500 grid-bg"
        data-testid="auth-checking"
      >
        <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.22em] uppercase">
          <Loader2 className="w-4 h-4 animate-spin" />
          Verifying session…
        </div>
      </div>
    );
  }

  if (status === "anon") return <Login />;

  // A temporary password grants no access to contact data until it is replaced.
  if (mustChangePassword) return <ChangePassword forced />;

  // Administrators cannot reach any data until two-step verification is on.
  if (mustEnrollMfa) return <MfaSetup forced />;

  return children;
}
